import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';

import DateTimePicker from './DateTimePicker';
import {
  TitleButton,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
} from './DateTimePickerDialog.styled';

const DateTimePickerContent = ({
  titleId,
  onClose,
  date,
  primaryAction,
  secondaryAction,
}) => {
  const [selectedDate, setSelectedDate] = useState(
    date ? new Date(date) : new Date()
  );

  const handlePrimaryActionClick = () => {
    onClose();
    primaryAction.onAction(selectedDate.toISOString());
  };

  const handleSecondaryActionClick = () => {
    onClose();
    if (secondaryAction) {
      secondaryAction.onAction();
    }
  };

  const secondary = secondaryAction ? (
    <Button onClick={handleSecondaryActionClick}>
      {secondaryAction.label}
    </Button>
  ) : null;

  return (
    <React.Fragment>
      <DialogTitle>
        <TitleButton
          id={titleId}
          aria-label="Close dialog"
          disableRipple
          onClick={onClose}
        >
          <CloseIcon />
        </TitleButton>
      </DialogTitle>
      <DialogContent>
        <DateTimePicker
          date={selectedDate}
          onChange={setSelectedDate}
          disablePast
        />
      </DialogContent>
      <DialogActions>
        {secondary}
        <Button onClick={handlePrimaryActionClick}>
          {primaryAction.label}
        </Button>
      </DialogActions>
    </React.Fragment>
  );
};

const ActionType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  onAction: PropTypes.func.isRequired,
});

DateTimePickerContent.propTypes = {
  titleId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  date: PropTypes.string,
  primaryAction: ActionType.isRequired,
  secondaryAction: ActionType,
};

DateTimePickerContent.defaultProps = {
  date: null,
  secondaryAction: null,
};

const DateTimePickerDialog = ({
  id,
  open,
  onClose,
  date,
  primaryAction,
  secondaryAction,
}) => {
  const titleId = `${id}-dialogTitle`;
  return (
    <Dialog
      scroll="paper"
      id={id}
      aria-labelledby={titleId}
      aria-modal
      open={open}
      onClose={onClose}
    >
      <DateTimePickerContent
        titleId={titleId}
        onClose={onClose}
        date={date}
        primaryAction={primaryAction}
        secondaryAction={secondaryAction}
      />
    </Dialog>
  );
};

DateTimePickerDialog.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  date: PropTypes.string,
  primaryAction: ActionType.isRequired,
  secondaryAction: ActionType,
};

DateTimePickerDialog.defaultProps = {
  date: null,
  secondaryAction: null,
};

export default DateTimePickerDialog;
